import { fetchGet, fetchPost, rootApi } from '../helpers/api';

const graphApi = `${rootApi}/history-data`;
const statisticApi = `${rootApi}/stations/statistic`;
const portfolioApi = `${rootApi}/stations/portfolio`;

export const loadGraphReferences = stationId => fetchGet(`${graphApi}/references/${stationId}`);
export const energyMeterList = stationName => fetchGet(`${statisticApi}/findCondition/${stationName}`);
export const statisticTotalize = stationName => fetchGet(`${statisticApi}/totalize/${stationName}`);
export const otherData = payload => fetchPost(`${statisticApi}/otherData`, payload);
export const biDirectionalMeter = stationName => fetchGet(`${statisticApi}/getBiDirectionalMeter/${stationName}`);
export const getDirectionalEnergyDataDates = payload => fetchPost(`${statisticApi}/getBiDirectionalDataDateList`, payload)
export const biDirectionalEnergyData = payload => fetchPost(`${statisticApi}/getBiDirectionalEnergyData`, payload);

export const getPortfolioLevel = () => fetchGet(`${portfolioApi}/getPortfolioLevel`);
export const portfolioTotalize = payload => fetchPost(`${portfolioApi}/totalizePortfolio`, payload);
export const getPortfolioDetails = payload => fetchPost(`${portfolioApi}/getPortfolioDetails`, payload);
export const getPortfolioData = payload => fetchPost(`${portfolioApi}/getPortfolioData`, payload);
export const getPortfolioStatisticsData = payload => fetchPost(`${portfolioApi}/getPortfolioStatistics`, payload);
export const getPortfolioInfo = payload => fetchPost(`${portfolioApi}/getPortfolioInfo`, payload);